var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 579.14 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.41,335.59h437.2a115,115,0,0,0,.28-229.9c-6.23-.09-46.7.47-76.91,29.93-20.25,19.73-30.51,46.85-30.51,80.6a27,27,0,0,0,54,0c0-18.48,4.7-32.52,13.95-41.71,14.43-14.33,36.88-14.84,38.67-14.86h.56a61,61,0,1,1,0,122H43.41a27,27,0,0,0,0,54Z",
    transform: "translate(-16.43 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.41,229.91H251.8A115,115,0,0,0,252.08,0c-6.31-.09-46.71.47-76.92,29.92-20.24,19.74-30.5,46.86-30.5,80.61a27,27,0,1,0,54,0c0-18.48,4.7-32.52,14-41.71C227,54.5,249.44,54,251.24,54h.56a61,61,0,1,1,0,122H43.41a27,27,0,0,0,0,54Z",
    transform: "translate(-16.43 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M480.61,382.09H43.41a27,27,0,1,0,0,54h437.2a61,61,0,1,1,0,122h-.56c-1.79,0-24.24-.54-38.67-14.87-9.25-9.19-13.95-23.22-13.95-41.71a27,27,0,0,0-54,0c0,33.75,10.26,60.87,30.51,80.61,29,28.27,67.4,29.93,76,29.93h.92a115,115,0,0,0-.28-229.9Z",
    transform: "translate(-16.43 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAir);
export default __webpack_public_path__ + "static/media/iconAir.98366562c78e7263f9c33fb1c7feeb76.svg";
export { ForwardRef as ReactComponent };